export default __webpack_public_path__ + "static/media/mohawk_today_white_logo.svg";